import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import type { TrialListingViewLayerOverrides } from '@modules/trials/validators/TrialListingViewLayerOverridesValidator'
import getArmGroupsForTrialDesign from './getArmGroupsForTrialDesign'

export type ParticipantGroupsForTrialDesign = {
  armGroups: {
    description: string | null
    name: string
    treatments: {
      name: string
    }[]
    type: 'Active Control' | 'Experimental Treatment' | 'Placebo Group'
  }[]
  title: string
}

export default function getParticipantGroupsForTrialDesign(
  trial: Pick<
    ClinicalTrialForListingPage,
    'armGroups' | 'interventions' | 'nctId'
  >,
  overrides?: TrialListingViewLayerOverrides['participantGroups'],
): ParticipantGroupsForTrialDesign {
  const defaultTitle = 'Participant Groups'
  const title = overrides?.title ?? defaultTitle

  if (overrides?.armGroups) {
    return {
      armGroups: overrides.armGroups.map((armGroup) => ({
        description: armGroup.description ?? null,
        name: armGroup.name,
        treatments: armGroup.treatments ?? [],
        type: armGroup.type ?? 'Experimental Treatment',
      })),
      title,
    }
  }

  const armGroupsFromTrial = getArmGroupsForTrialDesign(trial)
  return {
    armGroups: armGroupsFromTrial.map((armGroup) => ({
      description: armGroup.description,
      name: armGroup.name,
      treatments: armGroup.treatments.map((treatment) => ({
        name: treatment.name,
      })),
      type: armGroup.type,
    })),
    title,
  }
}
